import { Component, Input } from '@angular/core';

import { AlertType } from './types/alert.type';
import { TypoComponent } from '../typo/typo.component';
import { IconComponent } from '../icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'epmax-alert',
    imports: [TypoComponent, IconComponent, TranslateModule],
    templateUrl: './alert.component.html',
    styleUrl: './alert.component.scss'
})
export class AlertComponent {
    @Input() type: AlertType = "success";
    @Input() showIcon: boolean = true;
    @Input() label: string = '';


    public get iconName(): string {
        switch (this.type) {
            case "success":
                return "check_circle";

            case "danger":
                return "warning";

            case "warning":
                return "notification_important";

            case "info":
                return "info";

            default:
                return "info"
        }

    }

}
